
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/estate-agents/prime",
      function () {
        return require("private-next-pages/products/estate-agents/prime.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/estate-agents/prime"])
      });
    }
  